import {
  GET_ALL_SERVICES_LOADING,
  GET_ALL_SERVICES_SUCCESS,
  GET_ALL_SERVICES_FAILURE,
} from '../actions/services';

const initialState = {
  list: [],
  loading: false,
  error: null,
};

/**
 * @param {Object} service
 *
 * @return {Object}
 */
function formatService(service) {
  return {
    uuid: service.uuid,
    name: service.name,
    suppliersCount: service.suppliersCount,
    demandersCount: service.demandersCount,
  };
}

/**
 * Services reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function services(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_SERVICES_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ALL_SERVICES_SUCCESS: {
      const list = payload.list.map(formatService);

      return {
        ...state,
        loading: false,
        list,
      };
    }

    case GET_ALL_SERVICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: (payload && payload.status.message) || null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/services/reducers/services.js